export const teamData = [
        {
            name: "Sachin choudhary",
            position: "( Managing Director )",
            image: "assets/img/team-1.webp",
        },
        {
            name: "Mohit",
            position: "( Driver and Guide )",
            image: "assets/img/team-2.jpeg",
        },
        {
            name: "Ajay",
            position: "( Driver and Guide )",
            image: "assets/img/team-3.jpeg",
        },
        {
            name: "Sunil",
            position: "( Driver and Guide )",
            image: "assets/img/team-4.jpeg",
        }
    ];